import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-close-icon',
  templateUrl: './navigation-close.component.html'
})
export class NavigationCloseComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
